export default "__VITE_ASSET__HZkrKjbI__"